module.exports = __webpack_public_path__ + "img/correspondence--1882-1910--cover.a2a3df40.jpg";